var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"menu"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"menu","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M2,3 L25,3 L25,7 L2,7 L2,3 Z M2,12 L25,12 L25,16 L2,16 L2,12 Z M2,21 L25,21 L25,25 L2,25 L2,21 Z","id":"Combined-Shape","fill":"#F93616"}))]);
}

Menu.defaultProps = {"width":"27px","height":"27px","viewBox":"0 0 27 27","version":"1.1"};

module.exports = Menu;

Menu.default = Menu;
